import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import * as routePaths from './routePaths'
import { ProtectedRoute } from './Routes'
import { userRoleSuperUser } from '../common/constants'
import { NatsProvider } from '../providers/NatsProvider.jsx'
import LocalActivitySubList from '../components/Pages/EdgeAI/LocalActivitySubList.jsx'
import LocalActivityAddImages from '../components/Pages/EdgeAI/LocalActivityAddImages.jsx'
import LocalQualityCheck from '../components/Pages/EdgeAI/LocalQualityCheck.jsx'
import LocalCreateActivity from '../components/Pages/EdgeAI/LocalCreateActivity.jsx'
import LocalAddActivity from '../components/Pages/EdgeAI/LocalAddActivity.jsx'
import LocalViewActivity from '../components/Pages/EdgeAI/LocalViewActivity.jsx'
import LocalViewTemplate from '../components/Pages/EdgeAI/LocalViewTemplate.jsx'
import LocalModifyTemplate from '../components/Pages/EdgeAI/LocalModifyTemplate.jsx'
import LocalManageLockedFields from '../components/Pages/EdgeAI/LocalManageLockedField.jsx'
import { LocalImageExceptionDetails } from '../components/Pages/EdgeAI/LocalImageExceptionDetails.jsx'
// import LocalViewBoxTransmittals from '../components/Pages/EdgeAI/ViewBoxTransmittals.jsx'
// import LocalAddBoxTransmittals from '../components/Pages/EdgeAI/AddBoxTransmittals.jsx'
// import LocalBatchTransmittalDetails from '../components/Pages/EdgeAI/BatchTransmittalDetails.jsx'
import LocalBoxImageDetails from '../components/Pages/EdgeAI/LocalBoxImageDetails.jsx'
import LocalNewDashboard from '../components/Pages/EdgeAI/LocalNewDashboard.jsx'
import LocalBoxTransmittalExceptionDetails from '../components/Pages/EdgeAI/LocalBoxTransmittalExceptionDetails.jsx'
import ViewQualityCheckImages from '../components/Pages/EdgeAI/ViewQualityCheckImages.jsx'
import LocalBulkActivityImageUpload from '../components/Pages/EdgeAI/LocalBulkActivityImageUpload.jsx'
import ErrorPage from '../components/Pages/ErrorPage.jsx'

const EdgeAIRouter = ({ match }) => {
  return (
    <NatsProvider>
      <Switch>
        <ProtectedRoute path={`${match.path}${routePaths.ModifyTemplate}`} component={LocalModifyTemplate} />
        <ProtectedRoute path={`${match.path}${routePaths.boxImageDetails}`} component={LocalBoxImageDetails} />
        <ProtectedRoute path={`${match.path}${routePaths.createActivity}`} component={LocalCreateActivity} />
        <ProtectedRoute path={`${match.path}${routePaths.addActivity}`} component={LocalAddActivity} />
        <ProtectedRoute path={`${match.path}${routePaths.viewActivity}`} component={LocalViewActivity} />
        <ProtectedRoute allowedTo={[userRoleSuperUser]} path={`${match.path}${routePaths.viewTemplate}`} component={LocalViewTemplate} />
        <ProtectedRoute allowedTo={[userRoleSuperUser]} path={`${match.path}${routePaths.ManageLockedFields}`} component={LocalManageLockedFields} />
        <ProtectedRoute path={`${match.path}${routePaths.SmartCatalogDashboard}`} component={LocalNewDashboard} />
        {/* <ProtectedRoute path={`${match.path}${routePaths.viewBoxTransmittals}`} component={LocalViewBoxTransmittals} />
        <ProtectedRoute path={`${match.path}${routePaths.addBoxTransmittals}`} component={LocalAddBoxTransmittals} />
        <ProtectedRoute path={`${match.path}${routePaths.uploadBoxTransmittals}`} component={LocalAddBoxTransmittals} /> */}
        {/* <ProtectedRoute path={`${match.path}${routePaths.batchTransmittals}`} component={LocalBatchTransmittalDetails} /> */}
        <Route path={`${match.path}${routePaths.ImageExceptionDetails}/:label`} component={LocalImageExceptionDetails} />
        <ProtectedRoute path={`${match.path}${routePaths.boxTransmittalExceptionDetails}`} component={LocalBoxTransmittalExceptionDetails} />
        <ProtectedRoute path={`${match.path}${routePaths.activityList}`} component={LocalActivitySubList} />
        <ProtectedRoute path={`${match.path}${routePaths.activityAddImages}`} component={LocalActivityAddImages} />
        <ProtectedRoute path={`${match.path}${routePaths.bulkActivityImageUpload}`} component={LocalBulkActivityImageUpload} />
        <ProtectedRoute path={`${match.path}${routePaths.qualityCheck}`} component={LocalQualityCheck} />
        <ProtectedRoute path={`${match.path}${routePaths.localViewQcList}`} component={ViewQualityCheckImages} />
        <ProtectedRoute component={ErrorPage} />
      </Switch>
    </NatsProvider>
  )
}

EdgeAIRouter.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
}

export default EdgeAIRouter
